module.exports = __webpack_public_path__ + "media/paid-sound.d66452fd.ogg";